import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { billingApi } from "@/api/billingApi";

export default function PurchaseSuccess() {
  const [purchaseData, setPurchaseData] = useState<any>(null);

  const navigate = useNavigate();
  useEffect(() => {
    async function purchaseSuccess() {
      try {
        const url = new URL(window.location.href);
        const sessionId = url.searchParams.get("session_id");
        if (!sessionId) {
          throw new Error("Session ID is required");
        }

        const checkoutSuccessResponse = await billingApi.checkoutSuccess(
          sessionId
        );
        console.log(checkoutSuccessResponse);
        if (checkoutSuccessResponse.status === 200) {
          console.log("response 200", checkoutSuccessResponse.data);
          setPurchaseData(checkoutSuccessResponse.data);
          // setTimeout(() => {
          //   navigate("/inbox");
          // }, 3000);
        }
      } catch (error) {
        console.error(error);
        toast.error("Purchase failed: " + error);
      }
    }
    purchaseSuccess();
  }, []);
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h1 className="text-2xl font-bold text-green-500">Purchase Success</h1>
      {purchaseData && (
        <div className="mt-6 bg-white shadow-md rounded-lg p-6 w-full max-w-md">
          <h2 className="text-xl font-semibold mb-4 text-gray-800">
            Purchase Details
          </h2>
          <div className="mb-2 flex justify-between">
            <span className="font-medium text-gray-600">Status:</span>
            <span className="text-green-600 font-bold capitalize">
              {purchaseData.data.status}
            </span>
          </div>
          <div className="mb-2 flex justify-between">
            <span className="font-medium text-gray-600">Phone Number:</span>
            <span className="text-gray-800">
              {purchaseData.data.phone_number}
            </span>
          </div>
          <div className="mb-2 flex justify-between">
            <span className="font-medium text-gray-600">Package Name:</span>
            <span className="text-blue-700">
              {purchaseData.data.package_name}
            </span>
          </div>
        </div>
      )}
      <button
        onClick={() => {
          navigate("/post-login");
        }}
        className="bg-blue-500 text-white px-4 py-2 rounded-md"
      >
        Continue Setup
      </button>
    </div>
  );
}
